import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import StyleSwitcher from '../../components/StyleSwitcher';
import { bg02 } from '../../components/imageImport';

const Terms = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* Navbar */}
      <Navbar />

      {/* Start Home   */}
      <section
        className="bg-half-170 d-table w-100"
        style={{ background: `url(${bg02}) center` }}
      >
        <div className="bg-overlay bg-gradient-overlay-2"></div>
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-12">
              <div className="title-heading text-center">
                <h5 className="heading fw-semibold sub-heading text-white title-dark">
                  Terms
                </h5>
                {/* <p className="text-white-50 para-desc mx-auto mb-0"></p>   */}
              </div>
            </div>
            {/*end col  */}
          </div>
          {/*end row  */}

          <div className="position-middle-bottom">
            <nav aria-label="breadcrumb" className="d-block">
              <ul
                className="breadcrumb breadcrumb-muted mb-0 p-0"
                style={{ backgroundColor: 'transparent' }}
              >
                <li className="breadcrumb-item">
                  <a
                    href="/index"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/index');
                    }}
                  >
                    NFTxtreme
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Terms
                </li>
              </ul>
            </nav>
          </div>
        </div>
        {/*end container  */}
      </section>
      {/*end section  */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      {/* End Home   */}

      {/* Start Terms & Conditions   */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="card shadow border-0 rounded">
                <div className="card-body">
                  <h5 className="card-title">Introduction :</h5>
                  <p className="text-muted mt-4">
                  Welcome to NFTxtreme! By accessing and using our platform, you agree to be bound by the following terms and conditions ("Terms"). Please read them carefully before engaging with our services. If you do not agree with these Terms, you must discontinue use of our website and services immediately.
                  </p>

                  <h5 className="card-title mt-5">User Agreements :</h5>
                  <p className="text-muted mt-4">
                  By creating an account, purchasing, selling, or interacting with NFTs on our platform, you acknowledge that you have read, understood, and agree to these Terms.
                  </p>
                  <p className="text-muted">
                  You must be at least 18 years old to use this platform. By using our services, you confirm that you meet this age requirement.
                  </p>
                  <p className="text-muted">
                  Users are responsible for maintaining the confidentiality of their account credentials. Any unauthorized use of your account must be reported to us immediately.
Intellectual Property Rights
                  </p>

                  <h5 className="card-title mt-5">Restrictions :</h5>
                  <p className="text-muted mt-4">
                    You are specifically restricted from all of the following :
                  </p>
                  <ul className="list-unstyled text-muted">
                    <li className="mt-2">
                      <i
                        data-feather="arrow-right"
                        className="fea icon-sm me-2"
                      ></i>
                      Digital Marketing Solutions for Tomorrow
                    </li>
                    <li className="mt-2">
                      <i
                        data-feather="arrow-right"
                        className="fea icon-sm me-2"
                      ></i>
                      Our Talented & Experienced Marketing Agency
                    </li>
                    <li className="mt-2">
                      <i
                        data-feather="arrow-right"
                        className="fea icon-sm me-2"
                      ></i>
                      Create your own skin to match your brand
                    </li>
                    <li className="mt-2">
                      <i
                        data-feather="arrow-right"
                        className="fea icon-sm me-2"
                      ></i>
                      Digital Marketing Solutions for Tomorrow
                    </li>
                    <li className="mt-2">
                      <i
                        data-feather="arrow-right"
                        className="fea icon-sm me-2"
                      ></i>
                      Our Talented & Experienced Marketing Agency
                    </li>
                    <li className="mt-2">
                      <i
                        data-feather="arrow-right"
                        className="fea icon-sm me-2"
                      ></i>
                      Create your own skin to match your brand
                    </li>
                  </ul>

                  <h5 className="card-title mt-5">Users Question & Answer :</h5>

                  <div className="accordion mt-4 pt-2" id="buyingquestion">
                    <div className="accordion-item rounded">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button border-0"
                          style={{ backgroundColor: '#F8F8FC' }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          How does it work ?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse border-0 collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#buyingquestion"
                      >
                        <div className="accordion-body text-muted bg-white">
                        NFTs (Non-Fungible Tokens) are unique digital assets stored on the blockchain. On our platform, you can explore a wide variety of NFTs, purchase your favorites using supported cryptocurrencies, and showcase your collection in your digital wallet. Transactions are secure and transparent, ensuring authenticity.
                        </div>
                      </div>
                    </div>

                  

                    <div className="accordion-item rounded mt-2">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className="accordion-button border-0 collapsed"
                          style={{ backgroundColor: '#F8F8FC' }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          What do I need to do to start selling ?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse border-0 collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#buyingquestion"
                      >
                        <div className="accordion-body text-muted bg-white">
                        To start selling your NFTs, create an account and connect your crypto wallet. Upload your artwork or digital asset, set a price, and mint your NFT. Once minted, your NFT will be available for purchase on the marketplace. Ensure your creations are unique and comply with our guidelines.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item rounded mt-2">
                      <h2 className="accordion-header" id="headingFour">
                        <button
                          className="accordion-button border-0 collapsed"
                          style={{ backgroundColor: '#F8F8FC' }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          What happens when I receive an order ?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        className="accordion-collapse border-0 collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#buyingquestion"
                      >
                        <div className="accordion-body text-muted bg-white">
                        When you receive an order, you'll be notified instantly. The buyer's payment is securely processed via the blockchain and transferred to your wallet after the transaction is verified. You can then choose to showcase your sale or reinvest in creating more NFTs.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <a
                      href=""
                      onClick={(e) => e.preventDefault()}
                      className="btn btn-primary rounded-md mt-2 me-2"
                    >
                      Accept
                    </a>
                    <a
                      href=""
                      onClick={(e) => e.preventDefault()}
                      className="btn btn-outline-primary rounded-md mt-2"
                    >
                      Decline
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/*end col  */}
          </div>
          {/*end row  */}
        </div>
        {/*end container  */}
      </section>
      {/*end section  */}
      {/* End Terms & Conditions   */}

      {/* footer */}
      <Footer />

      {/* Style switcher  */}
      <StyleSwitcher />
    </>
  );
};

export default Terms;
